import { marca } from '../data/contenido';
import { hero } from '../data/fotos';
import servicios from '../data/servicios';

/*
 * Las tres lineas que se nombran bajo la marca salen marcadas desde el panel,
 * no de una lista de ids cableada aca. Antes eran tres llaves escritas en este
 * archivo: reordenar o renombrar un servicio dejaba la portada en silencio con
 * menos de tres, y nada lo avisaba.
 *
 * Si no hay ninguna marcada, se muestran las tres primeras, para que la
 * portada nunca quede vacia.
 */
const TRES = 3;

export default function Hero() {
  const marcadas = servicios.filter((s) => s.portada);
  const lineas = (marcadas.length ? marcadas : servicios).slice(0, TRES);

  return (
    <>
      <header className="hero" id="inicio">
        <div className="hero__alto">
          {/* Las dos partes del h1 son visibles: nada de texto oculto. */}
          <h1 className="hero__titulo">
            <span className="rotulo hero__rotulo">
              {marca.descripcion} · {marca.lugar}
            </span>
            <span className="hero__marca">{marca.nombre}</span>
          </h1>
          <ul className="hero__lineas">
            {lineas.map((linea) => (
              <li key={linea.titulo}>{linea.titulo}</li>
            ))}
          </ul>
        </div>
        <div className="hero__cue" aria-hidden="true" />
      </header>

      <div className="portada">
        <div className="portada__marco">
          <img src={hero.src} alt={hero.alt} fetchpriority="high" decoding="async" />
        </div>
      </div>
    </>
  );
}
